/* ============================================================================
   Preset profile avatars. The User.avatar field stores the id (e.g. "kaaba")
   and the client maps it to a colourful gradient + an illustrated SVG glyph.
   The SVGs themselves live in client/public/avatars/ and are loaded as <img>
   so their bytes never touch the JS bundle.
   To add a new one: drop the SVG in /public/avatars/, append an entry below.
   ============================================================================ */

export const AVATARS = [
  // ── Islamic / heritage ──
  { id: 'al-aqsa-mosque',   label: 'Al-Aqsa Mosque',      from: '#10b981', to: '#064e3b' },
  { id: 'dome-of-the-rock', label: 'Dome of the Rock',    from: '#ca8a04', to: '#3f6212' },
  { id: 'jerusalem',        label: 'Jerusalem',           from: '#d6a172', to: '#7c2d12' },
  { id: 'kaaba',            label: 'Kaaba',               from: '#525252', to: '#171717' },
  { id: 'quran',            label: 'Qur’an',              from: '#16a34a', to: '#14532d' },
  { id: 'tasbih',           label: 'Tasbih',              from: '#b45309', to: '#451a03' },
  { id: 'beads',            label: 'Beads',               from: '#a16207', to: '#451a03' },
  { id: 'turban',           label: 'Turban',              from: '#fafaf9', to: '#a16207' },
  { id: 'turban-1',         label: 'Turban (Cream)',      from: '#fde68a', to: '#92400e' },
  { id: 'turban-2',         label: 'Turban (Blue)',       from: '#3b82f6', to: '#1e3a8a' },
  { id: 'turban-3',         label: 'Turban (Red)',        from: '#dc2626', to: '#7f1d1d' },
  { id: 'keffiyeh',         label: 'Keffiyeh',            from: '#f87171', to: '#1f2937' },
  { id: 'flag',             label: 'Flag',                from: '#ef4444', to: '#7f1d1d' },

  // ── Architecture ──
  { id: 'palace',           label: 'Palace',              from: '#fbbf24', to: '#92400e' },
  { id: 'castle',           label: 'Castle',              from: '#d6a172', to: '#78350f' },
  { id: 'castle-1',         label: 'Castle (Stone)',      from: '#94a3b8', to: '#334155' },
  { id: 'castle-2',         label: 'Castle (Sand)',       from: '#fcd34d', to: '#78350f' },

  // ── Knights, armour, weapons ──
  { id: 'armour',           label: 'Armour',              from: '#9ca3af', to: '#1f2937' },
  { id: 'army',             label: 'Army',                from: '#84cc16', to: '#365314' },
  { id: 'chainmail',        label: 'Chainmail',           from: '#cbd5e1', to: '#475569' },
  { id: 'shield',           label: 'Shield',              from: '#dc2626', to: '#7f1d1d' },
  { id: 'shield-1',         label: 'Shield (Blue)',       from: '#3b82f6', to: '#1e3a8a' },
  { id: 'sword-and-shield', label: 'Sword & Shield',      from: '#94a3b8', to: '#92400e' },
  { id: 'swords',           label: 'Swords',              from: '#cbd5e1', to: '#0f172a' },
  { id: 'swords-1',         label: 'Swords (Steel)',      from: '#94a3b8', to: '#1e293b' },

  // ── Vehicles ──
  { id: 'tank',             label: 'Tank',                from: '#84cc16', to: '#1c1917' },
  { id: 'helicopter',       label: 'Helicopter',          from: '#65a30d', to: '#1f2937' },
  { id: 'unmanned',         label: 'Drone',               from: '#475569', to: '#0f172a' },
  { id: 'ship',             label: 'Ship',                from: '#0ea5e9', to: '#0c4a6e' },
  { id: 'ship-1',           label: 'Ship (Sail)',         from: '#38bdf8', to: '#1e3a8a' },
  { id: 'ship-2',           label: 'Ship (Sea)',          from: '#06b6d4', to: '#155e75' },
  { id: 'car',              label: 'Car',                 from: '#ef4444', to: '#7f1d1d' },
  { id: 'car-1',            label: 'Car (Blue)',          from: '#2563eb', to: '#1e3a8a' },
  { id: 'ferrari',          label: 'Ferrari',             from: '#dc2626', to: '#450a0a' },
  { id: 'bus',              label: 'Bus',                 from: '#facc15', to: '#854d0e' },
  { id: 'bus-1',            label: 'Bus (Red)',           from: '#f97316', to: '#7c2d12' },
  { id: 'bus-2',            label: 'Bus (Blue)',          from: '#3b82f6', to: '#1e40af' },

  // ── Flowers & nature ──
  { id: 'rose',             label: 'Rose',                from: '#fb7185', to: '#9f1239' },
  { id: 'flower',           label: 'Flower',              from: '#f472b6', to: '#86198f' },
  { id: 'flower-1',         label: 'Flower (Pink)',       from: '#f9a8d4', to: '#9d174d' },
  { id: 'flowers',          label: 'Flowers',             from: '#c084fc', to: '#581c87' },
  { id: 'iris',             label: 'Iris',                from: '#a855f7', to: '#3b0764' },
  { id: 'lotus-flower',     label: 'Lotus',               from: '#f472b6', to: '#be185d' },
  { id: 'tulips',           label: 'Tulips',              from: '#fb7185', to: '#9f1239' },
  { id: 'sunflower',        label: 'Sunflower',           from: '#fde047', to: '#a16207' },
  { id: 'mountain',         label: 'Mountain',            from: '#60a5fa', to: '#1e3a8a' },
  { id: 'mountain-1',       label: 'Mountain (Snow)',     from: '#bfdbfe', to: '#1e3a8a' },
  { id: 'world',            label: 'World',               from: '#22d3ee', to: '#0e7490' },

  // ── Treasures ──
  { id: 'jewelry',          label: 'Jewelry',             from: '#fcd34d', to: '#92400e' },
  { id: 'necklace',         label: 'Necklace',            from: '#facc15', to: '#854d0e' },
  { id: 'ring',             label: 'Ring',                from: '#fbbf24', to: '#78350f' },
  { id: 'diamond-ring',     label: 'Diamond Ring',        from: '#7dd3fc', to: '#1e3a8a' },
  { id: 'ruby',             label: 'Ruby',                from: '#f43f5e', to: '#881337' },

  // ── Misc ──
  { id: 'book',             label: 'Storybook',           from: '#b8860b', to: '#5e3f05' },
  { id: 'body',             label: 'Reader',              from: '#fde68a', to: '#7c2d12' },
];

export const DEFAULT_AVATAR_ID = 'kaaba';

export function getAvatar(id) {
  return AVATARS.find((a) => a.id === id) || null;
}

/** Parse the user.avatar field — supports either a preset id ("kaaba") or a
 *  plain URL ("https://…", "/uploads/…"). Returns { kind, value | preset }. */
export function parseAvatar(raw) {
  const v = String(raw || '').trim();
  if (!v) return { kind: 'empty' };
  if (/^(https?:|\/|data:)/.test(v)) return { kind: 'url', value: v };
  const preset = getAvatar(v);
  return preset ? { kind: 'preset', preset } : { kind: 'empty' };
}
